/** @jsxImportSource @emotion/react */
"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";

import type { ThemeType } from "../../../../../global/emotion";
import {
  fontSizes,
  fontWeights,
  numericMilliseconds,
  numericPercentages,
  spacing,
} from "../../../../../global/emotion";
import { ChevronDownIcon } from "../../icons/Icon/NavigationIcons";

const triggerStyle = (theme: ThemeType) => ({
  alignItems: "center",
  backgroundColor: theme.semanticColors.background,
  border: "none",
  color: theme.semanticColors.neutralsHighest,
  cursor: "pointer",
  display: "flex",
  fontFamily: theme.fontFamilies.sansSerif,
  fontSize: fontSizes.titleM,
  fontWeight: fontWeights.titleM,
  justifyContent: "space-between",
  paddingBlock: spacing.s,
  width: numericPercentages[100],
  "& > svg": {
    flexShrink: 0,
    transition: `transform ${numericMilliseconds[200]} ease-out`,
  },
  "&[data-state='open'] > svg": {
    transform: "rotate(180deg)",
  },
});

type AccordionTriggerProps = React.ComponentProps<
  typeof AccordionPrimitive.Trigger
>;

export function AccordionTrigger({
  children,
  ...props
}: AccordionTriggerProps) {
  return (
    <AccordionPrimitive.Trigger css={triggerStyle} {...props}>
      {children}
      <ChevronDownIcon />
    </AccordionPrimitive.Trigger>
  );
}
